<template>
	<!-- <div>
		<el-tabs v-model="activeName">
			<el-tab-pane label="未完成" name="未完成">
				<wpd></wpd>
			</el-tab-pane>
			<el-tab-pane label="已完成" name="已完成">
				<ypd></ypd>
			</el-tab-pane>
		</el-tabs>
	</div> -->
</template>

<script>
	import wpd from "./wpd.vue"
	import ypd from "./ypd.vue"
	export default {
		components: {
			wpd,
			ypd
		},
		data() {
			return {
				activeName: "未完成"
			}
		}
	}
</script>

<style>
</style>
